import { fetchBatchRecords, fetchBatchTemplate, submitShopBatchPaternity } from '@/services/api';
import { Modal, message } from 'antd';
import { produce } from 'immer';

const commonError = async ({ code, msg = '', data = {} }) => {
  Modal.error({
    title: '提交失败',
    content: msg,
  });
};

const DEFAULT_STATE = {
  currentPage: 0,
  pageSize: 20,
  totalPage: 0,
  totalItems: 0,
  data: [],
  templateFile: null,
  fileList: [],
};

export default {
  namespace: 'multiParent',

  state: {
    ...DEFAULT_STATE,
  },

  effects: {
    *fetchBatchTemplate(_, { call, put }) {
      const data = yield call(fetchBatchTemplate, { type: 2 });
      if (data) {
        yield put({
          type: 'setFieldValue',
          payload: { templateFile: data },
        });
      }
    },

    *fetchBatchPaternity({ payload }, { call, put, select }) {
      const { pageSize } = yield select(state => state.multiParent);
      const data = yield call(fetchBatchRecords, {
        type: 2,
        currentPage: payload,
        pageSize,
      });
      // 搜索后的结果
      if (data) {
        yield put({
          type: 'setFieldValue',
          payload: data,
        });
      }
    },
    *submitBatchPaternity({ payload }, { call, put, select }) {
      const { fileList } = yield select(state => state.multiParent);
      const { name, fileUrl } = fileList[0];
      const response = yield call(submitShopBatchPaternity, {
        fileName: name,
        fileUrl,
        type: 2,
      });
      if (response?.code === 200) {
        message.success('上传成功');
        yield put({
          type: 'fetchBatchPaternity',
        });
        yield put({
          type: 'setFieldValue',
          payload: { fileList: [] },
        });
      } else {
        commonError(response);
      }
    },
  },

  reducers: {
    setFieldValue(state, { payload }) {
      return produce(state, draft => {
        Object.keys(payload).forEach(key => {
          draft[key] = payload[key];
        });
      });
    },
  },
};
